import {
  TASKBOARD_FETCH_SUCCESS,
  TASKBOARD_ADD_TASK,
  TASKBOARD_UPDATE_TASK,
  TASKBOARD_DELETE_TASK,
  TASKBOARD_ADD_PROJECT,
  TASKBOARD_DELETE_PROJECT,
  TASKBOARD_UPDATE_PROJECT,
} from "./taskboard-actions";
import { ReduxAction } from "../../common/interfaces";
import { LOGOUT_SUCCESS } from "../../authentication/authentication-actions";

export interface Project {
  id: number;
  name: string;
  archived?: boolean;
}

export interface Task {
  id: number;
  title: string;
  description?: string;
  stage: "todo" | "in_progress" | "blocked" | "done";
  priority?: "low" | "medium" | "high";
  dueDate?: string;
  position: number;
  archived?: boolean;
  projectId: number;
  assigneeId?: number;
  project?: Project;
  assignee?: { id: number; firstName: string; lastName: string };
}

interface TaskBoardState {
  tasks: Task[];
  projects: Project[];
}

const createInitialState = (): TaskBoardState => ({
  tasks: [],
  projects: [],
});

export const taskBoardReducer = (
  state: TaskBoardState = createInitialState(),
  action: ReduxAction
): TaskBoardState => {
  const { payload, type } = action;
  switch (type) {
    case TASKBOARD_FETCH_SUCCESS:
      return { ...state, tasks: payload.tasks, projects: payload.projects };
    case TASKBOARD_ADD_TASK:
      return { ...state, tasks: [...state.tasks, payload.task] };
    case TASKBOARD_UPDATE_TASK:
      return {
        ...state,
        tasks: state.tasks.map((t) => (t.id === payload.task.id ? payload.task : t)),
      };
    case TASKBOARD_DELETE_TASK:
      return { ...state, tasks: state.tasks.filter((t) => t.id !== payload.id) };
    case TASKBOARD_ADD_PROJECT:
      return { ...state, projects: [...state.projects, payload.project].sort((a, b) => a.name.localeCompare(b.name)) };
    case TASKBOARD_DELETE_PROJECT:
      return { ...state, projects: state.projects.filter((p) => p.id !== payload.id) };
    case TASKBOARD_UPDATE_PROJECT:
      return {
        ...state,
        projects: state.projects
          .map((p) => (p.id === payload.project.id ? payload.project : p))
          .sort((a, b) => a.name.localeCompare(b.name)),
      };
    case LOGOUT_SUCCESS:
      return createInitialState();
    default:
      return state;
  }
};
